import React from "react";
import { Route } from "react-router-dom";
import {
  VerifyPhone,
  ProfilePage,
} from "@zillout/shared-components";
import {
  AccountProfileMenu,
  AccountFeedbackForm,
  AccountFeedbackHistory,
  AccountLoyaltyRewards,
  AccountVenueVisits,
} from "../components/AccountRouteWrapper";
import CustomerAppRedirect from "../components/CustomerAppRedirect";

export const authRoutes = (
  <>
    <Route path="/verify-phone" element={<VerifyPhone />} />
    <Route path="/verify-phone/:signinType" element={<VerifyPhone />} />
    <Route path="/account" element={<AccountProfileMenu />} />
    <Route path="/account/feedback" element={<AccountFeedbackForm />} />
    <Route path="/account/feedback-history" element={<AccountFeedbackHistory />} />
    <Route path="/account/visits" element={<AccountVenueVisits />} />
    <Route path="/account/loyalty" element={<AccountLoyaltyRewards />} />
    <Route path="/profile" element={<ProfilePage />} />
    <Route
      path="/user/wallet/cover-details/:coverUuid"
      element={<CustomerAppRedirect />}
    />
    <Route
      path="/user/wallet/cover-details/secure/:coverUuid"
      element={<CustomerAppRedirect />}
    />
    <Route
      path="/user/wallet/cover-details/:type/:eventId/:code"
      element={<CustomerAppRedirect />}
    />
  </>
);
